import { render, staticRenderFns } from "./NotificationEnableRow.vue?vue&type=template&id=1a7a199c"
import script from "./NotificationEnableRow.vue?vue&type=script&lang=js"
export * from "./NotificationEnableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports